export const ALL_COUNTRIES = { name: 'All Countries', code: '', flag: '🌍' };
export const USA = { name: 'USA', code: 'US', flag: '🇺🇸' };
export const BRAZIL = { name: 'Brazil', code: 'BR', flag: '🇧🇷' };
export const ITALY = { name: 'Italy', code: 'IT', flag: '🇮🇹' };
export const RUSSIA = { name: 'Russia', code: 'RU', flag: '🇷🇺' };
export const POLAND = { name: 'Poland', code: 'PL', flag: '🇵🇱' };
export const JAPAN = { name: 'Japan', code: 'JP', flag: '🇯🇵' };

export const COUNTRIES = [
  ALL_COUNTRIES,
  USA,
  BRAZIL,
  ITALY,
  RUSSIA,
  POLAND,
  JAPAN
];